export const formatEnumEntry = entry => {
    const words = entry.split("_");

    const capitalizedWords = words.map(word => word.toUpperCase()[0].toString() + word.toLowerCase().substring(1));
    return capitalizedWords.join(" ");
}

export const makeEnum = names => {
    const type = names
        .map((x, i) => [x, i])
        .reduce((a, c) => Object.assign(a, {[c[0]]: c[1]}))

    type.toString = s => {
        return formatEnumEntry(names[type[s]]);
    }

    type.enumerate = Object.freeze(names)

    return Object.freeze(type)
}

export const RerollTrait = makeEnum([
    "BgColor",
    "Outfit",
    "HandAccessory",
    "Mouth",
    "Eyes",
    "HeadAccessory"
])

export const Special = makeEnum([
    "NONE",
    "DEVIL",
    "GHOST",
    "HIPPIE",
    "JOKER",
    "PRISONER",
    "SQUID_GAME",
    "WHERES_WALDO",
    "HAZMAT",
    "ASTRONAUT"
]);

export const Dominant = makeEnum([
    "SKELETON",
    "VAMPIRE",
    "MUMMY",
    "GHOST",
    "WITCH",
    "FRANKENSTEIN",
    "WEREWOLF",
    "PUMPKINHEAD"
]);

export const Recessive = makeEnum([
    "SKELETON",
    "VAMPIRE",
    "MUMMY",
    "GHOST",
    "DEVIL",
    "KONG"
]);

export const BgColor = makeEnum([
    "DARK_BLUE",
    "GRAY",
    "LIGHT_BLUE",
    "ORANGE",
    "PINK",
    "PURPLE",
    "RED",
    "TAN",
    "TEAL",
    "GREEN",
    "RAINBOW"
]);

export const Outfit = makeEnum([
    "WHITE_SHORTS",
    "PINK_SHORTS",
    "GRAY_PANTS",
    "WHITE_AND_BLUE",
    "PURPLE_SHORTS",
    "PINK_AND_PURPLE",
    "BROWN_AND_WHITE",
    "BROWN_AND_BLUE",
    "BLUE_SHORTS",
    "BLUE_AND_WHITE",
    "UNDERGARMENTS",
    "LOUNGEWEAR",
    "HOBO",
    "SPORTS_JERSEY",
    "GOLD_CHAIN",
    "PAJAMAS",
    "OVERALLS",
    "SPEEDO",
    "NINJA_SUIT",
    "KARATE_UNIFORM",
    "NONE",
    "LUMBERJACK",
    "PRIEST",
    "TUX",
    "SKELETON",
    "CAMO",
    "ARMOR"
]);

export const HandAccessory = makeEnum([
    "NONE",
    "BLOODY_KNIFE",
    "BOW_AND_ARROW",
    "SWORD",
    "PITCHFORK",
    "WAND",
    "SPIKED_BASEBALL_BAT",
    "ENERGY_DRINK",
    "NINJA_STARS",
    "NUNCHUCKS",
    "POOP",
    "FLAMETHROWER",
    "HOOKS",
    "WEIGHTS",
    "SKULL",
    "BRAIN"
]);

export const Mouth = makeEnum([
    "NONE",
    "HAPPY",
    "MAD",
    "SMILE",
    "FANGS",
    "HAPPY_FANGS",
    "MAD_FANGS",
    "SMILE_FANGS",
    "SINGLE_TOOTH",
    "DIRTY_TEETH",
    "SMILE_DIRTY_TEETH",
    "MAD_DIRTY_TEETH",
    "BLOODY_FANGS",
    "BLACK_MASK",
    "HAPPY_BUCK_TEETH",
    "HAPPY_SINGLE_TOOTH",
    "MAD_SINGLE_TOOTH",
    "SMILE_SINGLE_TOOTH",
    "BREATHING_FIRE",
    "GOLD_GRILLS",
    "KISS",
    "SMOKING_JOINT"
]);

export const Eyes = makeEnum([
    "NONE",
    "BLACK_EYE",
    "BLACKOUT",
    "BLEEDING",
    "BLOODSHOT",
    "WATERY",
    "WHITE",
    "BIGGER_BLACK_EYES",
    "BIGGER_BLEEDING",
    "BIGGER_WATERY",
    "SMALLER_BLACK_EYES",
    "SMALLER_BLEEDING",
    "SMALLER_BLOODSHOT",
    "SMALLER_WATERY",
    "SMALLER",
    "SUNGLASSES",
    "EYE_PATCH",
    "VR_HEADSET",
    "DEAD",
    "_3D_GLASSES",
    "HEART_EYES",
    "LASER_GLASSES",
    "NINJA_MASK",
    "LASER_EYES"
]);

export const HeadAccessory = makeEnum([
    "NONE",
    "BUCKET_HAT",
    "FLOWER",
    "SPORTS_HEADBAND",
    "CHEF_HAT",
    "BLUE_DURAG",
    "RED_DURAG",
    "SPIKY_HAIR",
    "BONES",
    "RICE_HAT",
    "BEANIE_CAP",
    "SANTA_HAT",
    "HEAD_WOUND",
    "HEADPHONES",
    "GOLD_STUDS",
    "WIZARD_HAT",
    "LONG_HAIR",
    "AIR_PODS",
    "WHITE_PARTY_HAT",
    "BLUE_PARTY_HAT",
    "RED_PARTY_HAT",
    "GREEN_PARTY_HAT",
    "YELLOW_PARTY_HAT",
    "PURPLE_PARTY_HAT",
    "PIRATE_HAT",
    "KING_CROWN",
    "JOKER_HAT",
    "DEVIL_HORNS",
    "BRAINS"
]);
